import React from 'react';
import { useMEMTranslation } from '../../utils/text-utils';
import { Text, Button } from '../../providers/harmony-scope/lazy-enablers';
import { PRIVACY_NOTICE_LINK, SERVICE_AGREEMENT_LINK } from '../../constants/links';

export const SettingsPanelContent = () => {
  const { t } = useMEMTranslation();

  return (
    <>
      <Text slot="heading">{t('navHeaderSettings')}</Text>
      <br />
      <Button href={PRIVACY_NOTICE_LINK} appearance="link" target="_blank" external>
        {t('panelSettingsPrivacyNotice')}
      </Button>
      <br />
      <br />
      <Button href={SERVICE_AGREEMENT_LINK} appearance="link" target="_blank" external>
        {t('panelSettingsServiceAgreement')}
      </Button>
      {/* <br />
      <br />
      <Button href={THIRD_PARTY_SOFTWARE_LINK} appearance="link" target="_blank" external>{t('panelSettingsThirdPartySoftware') as string}</Button>
      <br />
      <br />
      <Button href={DISCLAIMER_LINK} appearance="link" target="_blank" external>{t('panelSettingsDisclaimer') as string}</Button> */}
    </>
  );
};
